<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-10 17:33:19
 * @LastEditTime: 2020-12-02 16:02:04
 * @LastEditors: wutt
 -->
<!--  -->
<template>
  <div class="navbar">
    <img
      src="../../../assets/onlineMap/logo.png"
      class="logo"
    >
    <div class="search">
      <UCPOIFuzzyKey ref="ucPOIFuzzyKey"></UCPOIFuzzyKey>
    </div>

    <div class="category">
      <ul class="categoryBox">
        <li class="categoryBox_li">
          <a @click="_routeClickHandler">
            <i class="route_line"></i>
            <span>路线</span>
          </a>
        </li>

        <li class="categoryBox_li">
          <div
            class="t-item tool-box"
            @click="_userCollectClickHandler"
          >

            <a class="further-content">
              <span class="com-icon  tool-icon-tool collection"></span>
              <span>收藏</span>
            </a>
          </div>
        </li>

        <li class="categoryBox_li">
          <div class="t-item tool-box">
            <a
              class="tool-content"
              @click="_toolClickHandler"
            >
              <span class="com-icon tool-icon-tool "></span>
              <span>工具</span>
              <em v-bind:class="{triangle_rotate:ucsetting.tool.toolSelectedStatus,triangle:true,tool_container_triangle:true}"></em>
            </a>

            <ul
              v-show="ucsetting.tool.toolSelectedStatus"
              class="tool-ul"
            >
              <li class="tool-li">
                <div
                  class="tool-item-box"
                  @click="_measureDistanceClickHandler"
                >
                  <a class="tool-item">
                    <span class="com-icon tool-icon-measure"></span>
                    <span>测量</span>
                  </a>
                </div>

                <div
                  class="tool-item-box"
                  @click="_measureAreaClickHandler"
                >
                  <a class="tool-item">
                    <span class="com-icon tool-icon-area"></span>
                    <span>测面</span>
                  </a>
                </div>

                <div
                  class="tool-item-box"
                  @click="_drawPointClickHandler"
                >
                  <a class="tool-item">
                    <span class="com-icon toolbd"></span>
                    <span>标点</span>
                  </a>
                </div>

                <div
                  class="tool-item-box"
                  @click="_drawPolylineClickHandler"
                >
                  <a class="tool-item">
                    <span class="com-icon toolbx"></span>
                    <span>标线</span>
                  </a>
                </div>

                <div
                  class="tool-item-box"
                  @click="_drawPolygonClickHandler"
                >
                  <a class="tool-item">
                    <span class="com-icon toolbm"></span>
                    <span>标面</span>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </li>

        <li class="categoryBox_li">
          <div class="t-item tool-box">
            <a
              class="further-content"
              @click="_moreClickHandler"
            >
              <span class="com-icon  tool-icon-tool further-box-icon"></span>
              <span>更多</span>
              <em v-bind:class="{triangle_rotate:ucsetting.tool.moreSelectedStatus,triangle:true,tool_container_triangle:true}"></em>
            </a>
            <ul
              v-show="ucsetting.tool.moreSelectedStatus"
              class="tool-ul"
            >

              <li class="tool-li">

                <!-- <div
                  class="tool-item-box"
                  @click="_printToolClickHandler"
                >
                  <a class="tool-item">
                    <span class="com-icon tool-icon tooldy"></span>
                    <span>打印</span>
                  </a>
                </div> -->

                <!-- 

                <div class="tool-item-box check_menu2_parent">
                  <a class="tool-item">
                    <span class="com-icon tool-icon toolty"></span>
                    <span>投影</span>
                  </a>
                </div>

                <div class="tool-item-box">
                  <a class="tool-item">
                    <span class="com-icon tool-icon share-icon"></span>
                    <span>分享</span>
                  </a>
                </div> -->

                <div
                  class="tool-item-box"
                  @click="_clearToolClickHandler"
                >
                  <a class="tool-item">
                    <span class="com-icon tool-icon-clear"></span>
                    <span>清空</span>
                  </a>
                </div>

                <div
                  class="tool-item-box"
                  @click="_fullscreenClickHandler"
                >
                  <a class="tool-item fullscreen-content">
                    <span class="com-icon tool-icon fullscreen-icon"></span>
                    <span id="span_fullscreen">全屏</span>
                  </a>
                </div>
              </li>

            </ul>

          </div>
        </li>
      </ul>
    </div>

    <div class="loginpan">

      <div v-if="networkIsPublic">
        <a
          :href="platformHref.login"
          @mouseover="_userMouseOverHandler()"
          @mouseleave="_userMouseOutHandler()"
        >
          <div :class="{logined:curUser,login:!curUser}">
            <span v-if="curUser">{{curUser.name}}</span>

          </div>

        </a>

      </div>

      <div
        v-if="!networkIsPublic"
        :class="{logined:curUser,login:!curUser}"
        @mouseover="_userMouseOverHandler()"
        @mouseleave="_userMouseOutHandler()"
        @click="_loginClickHandler"
      >
        <span v-if="curUser">{{curUser.name}}</span>

      </div>

      <div
        :class="{login_menu:true,noUserInfo:!ucsetting.tool.userOperVisible}"
        @mouseover="_userOperMouseOverHandler"
        @mouseout="_userOperMouseOutHandler"
      >
        <div v-if="networkIsPublic">
          <div class="login_menu_item">
            <a :href="platformHref.personalInfo">个人信息</a>
          </div>

          <div class="login_menu_item">
            <a :href="platformHref.changePassword">修改密码</a>
          </div>
          <div class="login_menu_item">
            <a :href="platformHref.logout">退出</a>
          </div>
        </div>

        <div v-if="!networkIsPublic">
          <div
            class="login_menu_item"
            @click="_logoutClickHandler"
          >
            退出
          </div>
        </div>

      </div>

    </div>

    <div class="seperator">
    </div>

    <div class="channel_other">
      <i class="channel_other_i" @click="_channelOtherClickHandler"></i>
      
      <div v-bind:class="{items:true, items_other:true,channel_other_i_hide:!ucsetting.tool.channelothersVisible}">
        <div class="top_arrow arror_other"></div>
        <a class="home" :href="platformHref.portal" target="_blank">
          <i class="home_i"> </i>
          <span>首页</span>
        </a>

        <a class="zhfw" :href="platformHref.thematicLayer" target="_blank">
          <i class="zhfw_i"></i>
          <span>专题图层</span>
        </a>

        <a class="dtapi" :href="platformHref.developmentCenter" target="_blank">
          <i class="dtapi_i"></i>
          <span>开发资源</span>
        </a>

        <a class="dxyy" :href="platformHref.typicalApp" target="_blank">
          <i class="dxyy_i"></i>
          <span>典型应用</span>
        </a>

        <a class="fwzy" :href="platformHref.resourceCenter" target="_blank">
          <i class="fwzy_i"></i>
          <span>服务资源</span>
        </a>

        <a class="yjfw" :href="platformHref.emergencyService" target="_blank">
          <i class="yjfw_i"></i>
          <span>应急服务</span>
        </a>

      </div>

    </div>

    <UCDistrict ref="ucDistrict"></UCDistrict>

    <UCFormUserVerify ref="ucUserVerify"></UCFormUserVerify>

  </div>
</template>

<script>
import UCPOIFuzzyKey from "../POISearch/UCPOIFuzzyKey.vue";
import UCDistrict from "../district/UCDistrict.vue";
import { UCNavBarEvent } from "./UCNavBarJs.js";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs";
import { TdtUser } from "../model/TdtUserJs.js";
import { MainMapInfo, MapToolType } from "../model/MainMapInfo.js";

import UCFormUserVerify from "./UCFormUserVerify.vue";

export default {
  name: "UCNavBar",
  data() {
    return {
      ucsetting: {
        tool: {
          toolSelectedStatus: false,

          moreSelectedStatus: false,

          userOperVisible: false,

          channelothersVisible:false,

        }
      },

      platformHref: {
        login: ServiceUrlConfig.platform_tdtsso_fullLogin,
        logout: ServiceUrlConfig.platform_tdtsso_fullLogout,
        personalInfo: "https://uums.tianditu.gov.cn/personalInfo",
        changePassword:"https://uums.tianditu.gov.cn/personalInfo?act=changePwd",

        portal:ServiceUrlConfig.platform_href_portal,
        thematicLayer:ServiceUrlConfig.platform_href_thematicLayer,
        developmentCenter:ServiceUrlConfig.platform_href_development_center,
        typicalApp:ServiceUrlConfig.platform_href_typical_app,
        resourceCenter:ServiceUrlConfig.platform_href_resourceCenter,
        emergencyService:ServiceUrlConfig.platform_href_emergency_service,
      },

      curUser: null,

      curMap: null,

      networkIsPublic: TdtUser.envIsPublic
    };
  },

  components: { UCPOIFuzzyKey, UCDistrict, UCFormUserVerify },

  computed: {},

  mounted() {},

  methods: {
    init() {
      (this.networkIsPublic = TdtUser.envIsPublic),
        (this.$refs.ucPOIFuzzyKey.curMap = this.curMap);

      this._initEvents();

      if (this.networkIsPublic) {
        this._getUser();
      }
    },

    /**
     * 隐藏建议词
     */
    hiddenUCSuggestKey() {
      this.$refs.ucPOIFuzzyKey.hiddenUCSuggestKey();
    },

    /**
     * 隐藏工具
     */
    hiddenTool() {
      this.ucsetting.tool.toolSelectedStatus = false;
      this.ucsetting.tool.moreSelectedStatus = false;
      this.ucsetting.tool.channelothersVisible=false;

      if (this.$refs.ucDistrict) {
        this.$refs.ucDistrict.closeCityPopu();
      }
    },

    off_suggestPoiItemClick(callback) {
      this.$refs.ucPOIFuzzyKey.off_suggestPoiItemClick(callback);
    },

    on_suggestPoiItemClick(callback) {
      this.$refs.ucPOIFuzzyKey.on_suggestPoiItemClick(callback);
    },

    on_poiSearchClick(callback) {
      this.$refs.ucPOIFuzzyKey.on_poiSearchClick(callback);
    },

    on_switch_routeLine(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_switch_routeLine, callback);
      }
    },

    on_cityPickerChanger(callback) {
      if (callback && this.$refs.ucDistrict) {
        this.$refs.ucDistrict.on_cityPickerChanger(callback);
      }
    },

    on_measureDistanceToolClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_measureDistance, callback);
      }
    },

    on_measureAreaToolClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_measureArea, callback);
      }
    },

    on_drawPointToolClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_drawPoint, callback);
      }
    },

    on_drawPolylineToolClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_drawPolyline, callback);
      }
    },

    on_drawPolygonToolClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_drawPolygon, callback);
      }
    },

    on_userCollectClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_userCollect, callback);
      }
    },

    on_clearToolClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_clear, callback);
      }
    },

    on_fullscreenClick(callback) {
      if (callback) {
        this.$on(UCNavBarEvent.ucNavBar_tool_fullscreen, callback);
      }
    },

    ucDistrictCityChange(mapLevel, mapExtent) {
      if (this.$refs.ucDistrict) {
        this.$refs.ucDistrict.cityChange(mapLevel, mapExtent);
      }
    },

    /**
     * 初始化事件
     */
    _initEvents() {
      // let self = this;
      if (this.$refs.ucDistrict) {
        this.$refs.ucDistrict.off_ucClick(this._ucDistrict_ucClickHandler);
        this.$refs.ucDistrict.on_ucClick(this._ucDistrict_ucClickHandler);
      }

      if (this.$refs.ucUserVerify) {
        this.$refs.ucUserVerify.off_verifySucceed(
          this._ucUserVerify_verifySucceedHandler
        );
        this.$refs.ucUserVerify.on_verifySucceed(
          this._ucUserVerify_verifySucceedHandler
        );
      }

      if (this.$refs.ucPOIFuzzyKey) {
        this.$refs.ucPOIFuzzyKey.off_UCPOIInputFocus(
          this._ucPoiFuzzyKey_POIInputFocusHandler
        );
        this.$refs.ucPOIFuzzyKey.on_UCPOIInputFocus(
          this._ucPoiFuzzyKey_POIInputFocusHandler
        );
      }
    },

    _ucDistrict_ucClickHandler() {
      this.ucsetting.tool.toolSelectedStatus = false;
      this.ucsetting.tool.moreSelectedStatus = false;
      this.ucsetting.tool.channelothersVisible=false;
    },

    _ucUserVerify_verifySucceedHandler(user) {
      this.curUser = user;
      TdtUser.currentUser = user;
    },

    _ucPoiFuzzyKey_POIInputFocusHandler() {
      this.hiddenTool();
    },

    _getUser() {
      TdtUser.currentUser = null;

      let self = this;

      let sessionUrl = ServiceUrlConfig.platform_tdtsso_getsession;

      TdtUser.getsession(
        sessionUrl,
        function(response) {
          self.curUser = TdtUser.fromJson(response.data);

          TdtUser.currentUser = self.curUser;
        },
        function(error) {}
      );
    },

    _loginClickHandler() {
      if (this.curUser) return;

      this.$refs.ucUserVerify.init();
      this.$refs.ucUserVerify.showForm();
    },

    _userMouseOverHandler() {
      if (this.curUser) {
        this.ucsetting.tool.userOperVisible = true;
      } else {
        this.ucsetting.tool.userOperVisible = false;
      }
    },

    _userMouseOutHandler() {
      this.ucsetting.tool.userOperVisible = false;
    },

    _userOperMouseOverHandler() {
      if (this.curUser) {
        this.ucsetting.tool.userOperVisible = true;
      } else {
        this.ucsetting.tool.userOperVisible = false;
      }
    },

    _userOperMouseOutHandler() {
      this.ucsetting.tool.userOperVisible = false;
    },

    _userInfoClickHandler() {
      if (this.curUser) {
        window.open(this.platformHref.personalInfo);
      }
    },

    _userPwdChangeClickHandler() {
      if (this.curUser) {
        window.open(this.platformHref.changePassword);
      }
    },

    _logoutClickHandler() {
      this.curUser = null;
      TdtUser.currentUser = null;

      this.ucsetting.tool.userOperVisible = false;
    },

    _routeClickHandler() {
      //隐藏工具
      this.hiddenTool();

      this.$emit(UCNavBarEvent.ucNavBar_switch_routeLine);
    },

    _toolClickHandler() {
      this.ucsetting.tool.toolSelectedStatus = !this.ucsetting.tool
        .toolSelectedStatus;

      this.ucsetting.tool.moreSelectedStatus = false;
      this.ucsetting.tool.channelothersVisible=false;

      if (this.$refs.ucDistrict) {
        this.$refs.ucDistrict.closeCityPopu();
      }
    },

    _moreClickHandler() {
      this.ucsetting.tool.moreSelectedStatus = !this.ucsetting.tool
        .moreSelectedStatus;

      this.ucsetting.tool.toolSelectedStatus = false;
      this.ucsetting.tool.channelothersVisible=false;
      
      if (this.$refs.ucDistrict) {
        this.$refs.ucDistrict.closeCityPopu();
      }
    },

    _measureDistanceClickHandler() {
      MainMapInfo.currentTool = MapToolType.tool_measureDistance;

      this.$emit(UCNavBarEvent.ucNavBar_tool_measureDistance);

      this.ucsetting.tool.toolSelectedStatus = false;
    },

    _measureAreaClickHandler() {
      MainMapInfo.currentTool = MapToolType.tool_measureArea;

      this.$emit(UCNavBarEvent.ucNavBar_tool_measureArea);

      this.ucsetting.tool.toolSelectedStatus = false;
    },

    _drawPointClickHandler() {
      MainMapInfo.currentTool = MapToolType.tool_drawPoint;
      
      this.$emit(UCNavBarEvent.ucNavBar_tool_drawPoint);

      this.ucsetting.tool.toolSelectedStatus = false;
    },

    _drawPolylineClickHandler() {
      MainMapInfo.currentTool = MapToolType.tool_drawPolyline;

      this.$emit(UCNavBarEvent.ucNavBar_tool_drawPolyline);

      this.ucsetting.tool.toolSelectedStatus = false;
    },

    _drawPolygonClickHandler() {
      MainMapInfo.currentTool = MapToolType.tool_drawPolygon;

      this.$emit(UCNavBarEvent.ucNavBar_tool_drawPolygon);

      this.ucsetting.tool.toolSelectedStatus = false;
    },

    _userCollectClickHandler() {
      //隐藏工具
      this.hiddenTool();

      this.$emit(UCNavBarEvent.ucNavBar_tool_userCollect);

      this.ucsetting.tool.toolSelectedStatus = false;
    },

    _printToolClickHandler() {},

    _clearToolClickHandler() {
      this.$refs.ucPOIFuzzyKey.clearInput();
      this.$emit(UCNavBarEvent.ucNavBar_tool_clear);
      this.ucsetting.tool.moreSelectedStatus = false;
    },

    _fullscreenClickHandler() {
      this.$emit(UCNavBarEvent.ucNavBar_tool_fullscreen);

      this.ucsetting.tool.moreSelectedStatus = false;
    },

    _channelOtherClickHandler()
    {
        this.ucsetting.tool.channelothersVisible=!this.ucsetting.tool.channelothersVisible;
        
        this.ucsetting.tool.toolSelectedStatus=false;
        this.ucsetting.tool.moreSelectedStatus=false;
        if (this.$refs.ucDistrict) {
        this.$refs.ucDistrict.closeCityPopu();
      }
        
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  top: 0;
  width: 100%;
  height: 51px;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  z-index: 12;
  position: absolute;
  transition: 0.3s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  border-collapse: separate;

  .logo {
    // margin-left: 20px;
    // margin-top: 10px;
    width: 165px;
    height: 48px;
    float: left;
    cursor: pointer;
  }
}

.ucSearch {
  top: 15px;
  left: 12px;
  margin-bottom: 5px;
  width: 330px;
  position: absolute;
}

.imgRoute {
  cursor: pointer;
  position: absolute;
  right: 0px;
  top: 15px;
  width: 31px;
  height: 40px;
}

.search {
  width: 300px;
  height: 40px;
  line-height: 40px;
  margin-top: 6px;
  // margin-left: 20px;
  float: left;

  .search_content {
    position: relative;
    border: 1px solid #b8b8b8;
    float: left;
  }
}

.category {
  float: left;
  font-size: 13px;
  position: relative;
  color: #333;

  .categoryBox {
    padding: 0;
    margin-top: 10px;
    height: 34px;
    position: absolute;
    width: 500px;
    background: #fff;
    left: 0;

    .categoryBox_li {
      height: 34px;
      line-height: 34px;
      margin-right: 20px;
      display: inline-block;
    }
  }

  .route_line {
    background-position: -362px -331px;
    float: left;
    margin: 10px 5px 10px 15px;
  }

  a:hover {
    color: #3385ff;
  }

  a {
    color: #000;
    float: left;
    text-decoration: none;
    height: 24px;
    cursor: pointer;
  }

  i {
    display: none;
    background: url("../../../assets/onlineMap/icon.png") #fff;
    background-repeat: no-repeat;
    display: inline-block;
    width: 16px;
    height: 16px;
    // float: left;
    // margin: 10px 5px;
  }
}

.t-item {
  padding-left: 5px;
  position: relative;
  float: left;
  padding-right: 0;
}

.com-icon {
  display: inline-block;
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-repeat: no-repeat;
  height: 16px;
  width: 17px;
}

.tool-icon-tool {
  float: left;
  margin-right: 5px;
  margin-top: 10px;
  background-position: -84px 0;
}

.tool_container_triangle {
  margin-left: 5px;
  float: right;
  margin-top: 13px;
}

.triangle {
  width: 11px;
  height: 6px;
  background: url("../../../assets/onlineMap/icon.png") #fff;
  background-repeat: no-repeat;
  background-position: -339px -222px;
  transition: 0.3s;
}

.triangle_rotate {
  transform: rotate(180deg);
}

.tool-ul {
  position: absolute;
  width: 90px;
  background: #fff;
  top: 34px;
  left: -14px;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.15);
  padding: 0;
  margin: 0;
}

.tool-li {
  // height: 120px;
  width: 100%;
  display: block;
  padding: 0;
  margin: 0;
}

.tool-item-box {
  position: relative;
}

.tool-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0;
  margin-top: 0;
}

.tool-icon-measure {
  float: left;
  margin-right: 5px;
  background-position: -295px 0;
}

.tool-icon-area {
  float: left;
  margin-right: 5px;
  background-position: -324px 0;
}

.tool-icon-clear {
  float: left;
  margin-right: 5px;
  background-position: -138px 0;
}

.further-box-icon {
  background-position: -467px -332px;
}

.collection {
  background-position: -387px -330px;
}

.tool-text {
  height: 34px;
  line-height: 34px;
  display: inline-block;
  font-size: 13px;
  font-style: normal;
  color: #333;
}

.tooldy {
  float: left;
  margin-right: 5px;
  background-position: -355px 0;
}

.fullscreen-icon {
  float: left;
  margin-right: 5px;
  background-position: -164px 0;
}

.toolty {
  float: left;
  margin-right: 5px;
  background-position: -414px 0;
}

.share-icon {
  float: left;
  margin-right: 5px;
  background-position: -108px 0;
}

.toolbd {
  float: left;
  margin-right: 5px;
  background-position: -41px -25px;
}

.toolbx {
  float: left;
  margin-right: 5px;
  background-position: -65px -26px;
}

.toolbm {
  float: left;
  margin-right: 5px;
  background-position: -91px -26px;
}

.loginpan {
  float: right;
  text-align: center;
  font-weight: 700;
  background-color: #fff;
  margin-right: 30px;
  margin-top: 15px;
}

.login {
  border-radius: 2px;
  font-size: 12px;
  color: #3385ff;
  cursor: pointer;
  width: 21px;
  height: 21px;
  line-height: 21px;
  background: url("../../../assets/onlineMap/icon.png");
  background-repeat: no-repeat;
  background-position: -28px -322px;
  // margin-right: 60px;
}

.logined {
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #3385ff;
  cursor: pointer;
  border: 1px solid #3385ff;
  border-radius: 2px;
  padding: 0 4px;
}

.login_menu {
  border: 1px solid #3385ff;
  border-bottom: none;
  border-top: none;
  color: #2774c9;
  letter-spacing: 1px;
  margin-left: -5px;
  margin-right: -5px;
  // margin-top: 1px;
  overflow: hidden;
}

.noUserInfo {
  display: none;
}

.login_menu_item {
  border-bottom: 1px solid #3385ff;
  text-align: center;
  background-color: #fff;
  a {
    color: #3385ff;
  }
}

.login_menu_item,
.logined {
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  color: #3385ff;
  cursor: pointer;
}

.seperator {
  width: 1px;
  height: 20px;
  background-color: #d4d4d4;
  float: right;
  margin: 15px 15px;
}

.channel_other {
  margin: 15px 0;
  position: relative;
  float: right;

  span {
    float: left;
    line-height: 12px;
    display: block;
    width: 100%;
    text-align: center;
    margin-top: 5px;
  }

  a {
    font-size: 12px;
    text-decoration: none;
    color: #000;
    width: 80px;
    height: 82px;
    display: block;
    float: left;
    margin-bottom: 30px;
  }

  .channel_other_i_hide
  {
    display: none;
  }

  .channel_other_i {
    width: 19px;
    height: 19px;
    display: block;
    background: url("../../../assets/onlineMap/icon.png");
    background-repeat: no-repeat;
    background-position: -30px 0;
    cursor: pointer;
  }

  .items {
    position: absolute;
    background: #fff;
    top: 35px;
    padding-top: 30px;
    padding-left: 30px;
    padding-right: 30px;
    width: 312px;
    border: 1px solid #b2b2b2;
  }

  .items_other {
    right: -50px;
  }

  .top_arrow {
    position: absolute;
    top: -10px;
    background: url("../../../assets/onlineMap/icon_channel.png");
    background-repeat: no-repeat;
    background-position: -222px -72px;
    width: 16px;
    height: 10px;
  }

  .arror_other {
    left: 245px;
  }

  .home {
    .home_i {
      width: 46px;
      height: 46px;
      background: url("../../../assets/onlineMap/icon_channel.png");
      display: block;
      background-repeat: no-repeat;
      float: left;
      margin: 5px 17px;
      background-position: 0 0;
    }
  }

  .zhfw {
    .zhfw_i {
      width: 46px;
      height: 46px;
      background: url("../../../assets/onlineMap/icon_channel.png");
      display: block;
      background-repeat: no-repeat;
      float: left;
      margin: 5px 17px;
      background-position: -112px 0;
    }
  }

  .dtapi {
    .dtapi_i {
      width: 46px;
      height: 37px;
      background: url("../../../assets/onlineMap/icon_channel.png");
      display: block;
      background-repeat: no-repeat;
      float: left;
      margin: 5px 17px;
      margin-top: 13px;
      background-position: -298px -5px;
    }
  }

  .dxyy {
    .dxyy_i {
      width: 42px;
      height: 46px;
      background: url("../../../assets/onlineMap/icon_channel.png");
      display: block;
      background-repeat: no-repeat;
      float: left;
      margin: 5px 17px;
      background-position: -410px 0;
    }
  }

  .fwzy {
    .fwzy_i {
      width: 46px;
      height: 38px;
      background: url("../../../assets/onlineMap/icon_channel.png");
      display: block;
      background-repeat: no-repeat;
      float: left;
      margin: 5px 17px;
      margin-top: 13px;
      background-position: 0 -69px;
    }
  }

  .yjfw {
    .yjfw_i {
      width: 45px;
      height: 45px;
      background: url("../../../assets/onlineMap/icon_channel.png");
      display: block;
      background-repeat: no-repeat;
      float: left;
      margin: 5px 17px;
      background-position: -112px -66px;
    }
  }
}
</style>
